import React, { useCallback } from 'react'
import SearchableAsyncSelectLayout from 'tennders-common/form/components/new-inputs/SearchableAsyncSelectLayout'
import { useDetectClickOutside } from 'react-detect-click-outside'
import GHref from 'tennders-market/common/components/element/GHref'
import styles from '../../styles/transactionSelect.module.scss'

const SearchableAsyncSelect = ({ onSet, fetchCallback, children, disabled, labelKey }) => {
  const [modalOpen, setModalOpen] = React.useState(false)
  const closeDropdown = useCallback(() => setModalOpen(false), [])
  const ref = useDetectClickOutside({
    onTriggered: closeDropdown,
    disableClick: true
  })
  const onSelect = (id) => {
    onSet(id)
    setModalOpen(false)
  }

  return (
    <div className={styles.outerContainer}>
      <div onClick={() => !disabled && setModalOpen(true)}>
        {children}
      </div>
      {modalOpen ? (
        <div ref={ref} className={styles.innerContainer}>
          <GHref onClick={() => setModalOpen(false)} className="close-modal"></GHref>
          <SearchableAsyncSelectLayout labelKey={labelKey} fetchCallback={fetchCallback} onSelect={onSelect} />
        </div>
      ) : null}
    </div>
  )
}

export default SearchableAsyncSelect
